import { createAction, props } from '@ngrx/store';

import { FeatureFlag } from '../../models/feature-flag.model';

const FeatureFlagsActions = {
    loadFeatureFlags: '[Feature Flags] Load Feature Flags',
    loadFeatureFlagsSuccess: '[Feature Flags] Load Feature Flags Success',
    loadFeatureFlagsFailure: '[Feature Flags] Load Feature Flags Failure',
};

export const loadFeatureFlags = createAction(FeatureFlagsActions.loadFeatureFlags);

export const loadFeatureFlagsSuccess = createAction(
    FeatureFlagsActions.loadFeatureFlagsSuccess,
    props<{ featureFlags: FeatureFlag[] }>(),
);

export const loadFeatureFlagsFailed = createAction(
    FeatureFlagsActions.loadFeatureFlagsFailure,
    props<{ error: string }>(),
);

